import script from "./ObjetivesRow.vue?vue&type=script&setup=true&lang=js"
export * from "./ObjetivesRow.vue?vue&type=script&setup=true&lang=js"

import "./ObjetivesRow.vue?vue&type=style&index=0&id=db98da80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db98da80"]])

export default __exports__